import React from 'react';
import { FaBuilding, FaBriefcase, FaTrophy, FaUserCheck, FaMagic, FaFileAlt } from 'react-icons/fa';
import '../components/recruiterProfiler/login/loginPage.css'; // Import for the custom background

const InfoPanel = () => {
  return (
    // The parent div covers the left half and applies the custom background
    <div className="hidden lg:flex flex-col  w-1/2 2xl:w-[60%] relative text-gray-333 bg-[#FFFDFA] text-left"> 
    <div className='absolute right-[1px]'>
      <svg  className='h-[6rem] w-[9rem]' viewBox="0 0 932 684" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_f_0_1)">
<g filter="url(#filter1_d_0_1)">
<circle cx="770.6" cy="203" r="259" fill="url(#paint0_linear_0_1)" fill-opacity="0.56" shape-rendering="crispEdges"/>
</g>
</g>
<g filter="url(#filter2_f_0_1)">
<circle cx="409.6" cy="529" r="92" fill="url(#paint1_linear_0_1)" fill-opacity="0.56"/>
</g>
<g filter="url(#filter3_f_0_1)">
<circle cx="109.1" cy="307.5" r="46.5" fill="url(#paint2_linear_0_1)" fill-opacity="0.56"/>
</g>
<defs>
<filter id="filter0_f_0_1" x="419.8" y="-147.8" width="701.6" height="701.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="40.9" result="effect1_foregroundBlur_0_1"/>
</filter>
<filter id="filter1_d_0_1" x="507.6" y="-56" width="526" height="526" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape"/>
</filter>
<filter id="filter2_f_0_1" x="255" y="374.4" width="309.2" height="309.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="31.3" result="effect1_foregroundBlur_0_1"/>
</filter>
<filter id="filter3_f_0_1" x="-0.000389099" y="198.4" width="218.2" height="218.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="31.3" result="effect1_foregroundBlur_0_1"/>
</filter>
<linearGradient id="paint0_linear_0_1" x1="770.6" y1="-56" x2="770.6" y2="462" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6CF90"/>
<stop offset="1" stop-color="#B3915A"/>
</linearGradient>
<linearGradient id="paint1_linear_0_1" x1="409.6" y1="437" x2="409.6" y2="621" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6CF90"/>
<stop offset="1" stop-color="#B3915A"/>
</linearGradient>
<linearGradient id="paint2_linear_0_1" x1="109.1" y1="261" x2="109.1" y2="354" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6CF90"/>
<stop offset="1" stop-color="#B3915A"/>
</linearGradient>
</defs>
</svg>

    </div>
    <div className='absolute top-0 left-0 '>
      <svg  className='h-[2rem] w-[3rem]' viewBox="0 0 295 162" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_f_2129_896)">
<circle cx="71" cy="-62" r="161" fill="url(#paint0_linear_2129_896)" fill-opacity="0.56"/>
</g>
<defs>
<filter id="filter0_f_2129_896" x="-152.6" y="-285.6" width="447.2" height="447.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="31.3" result="effect1_foregroundBlur_2129_896"/>
</filter>
<linearGradient id="paint0_linear_2129_896" x1="71" y1="-223" x2="71" y2="99" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6CF90"/>
<stop offset="1" stop-color="#B3915A"/>
</linearGradient>
</defs>
</svg>

    </div>

      {/* Logo */}
      <div className='flex flex-col p-8 gap-6 h-[60%]'>
      <div className=" flex flex-col font-bold">
        <img src={require('../assets/MphLogo.png')} alt="MPH" className="w-24" />
        <div className='flex text-[0.45rem] font-semibold '> EXPERTS BEYOND BORDERS</div>
      </div>
      <div className='flex flex-col gap-4'>
      <div className='text-3xl font-semibold bg-gradient-to-r from-[#AE8D5A] to-[#C6A165] bg-clip-text text-transparent'>Who we are</div>
      <div className='flex flex-col font-semibold gap-2 text-[#393939] text-xs'>
        <p>With 40+ years of expertise, MPH connects talented professionals to major technical projects across MENA, Africa, Europe, and Asia. Based in Dubai, we support key industries including Oil & Gas, Nuclear, Renewable Energy, Mining, Waste & Water Management, and Aeronautics.</p>
        <p>We match your skills with the right opportunities and ensure a smooth, supported career journey from project start to long-term operations.</p>
        <p>Join MPH and contribute to global infrastructure and the energy transition—advancing as a recognized expert in your field.</p>

      </div>
      </div>
      </div>
      <div className='w-full h-full login-resume-left-bg  '>

      </div>

    </div>
  );
};

export default InfoPanel;